function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./manual-production-log'),
  logManualProduction = _require.logManualProduction;
function timestampDigitCount(value) {
  var n = Number(value);
  if (!Number.isFinite(n)) {
    return String(value).replace(/^-/, '').length;
  }
  if (n === 0) {
    return 1;
  }
  return Math.floor(Math.log10(Math.abs(n))) + 1;
}
function inferTimestampUnits(digitCount) {
  if (digitCount <= 10) {
    return 'seconds (likely)';
  }
  if (digitCount === 11 || digitCount === 12) {
    return 'milliseconds (uncertain; 11-12 digits)';
  }
  if (digitCount === 13) {
    return 'milliseconds (likely)';
  }
  if (digitCount === 14 || digitCount === 15) {
    return 'microseconds (uncertain; 14-15 digits)';
  }
  if (digitCount === 16) {
    return 'microseconds (likely)';
  }
  if (digitCount >= 19) {
    return 'nanoseconds (likely)';
  }
  return "unknown (".concat(digitCount, " digits)");
}
function toIsoStringSafe(ms) {
  var n = Number(ms);
  if (!Number.isFinite(n)) {
    return 'invalid (non-finite)';
  }
  try {
    return new Date(n).toISOString();
  } catch (err) {
    return "invalid (".concat((err === null || err === void 0 ? void 0 : err.message) || err, ")");
  }
}
function isTimestampMisordered(previous, current) {
  var prev = Number(previous);
  var curr = Number(current);
  return !Number.isFinite(prev) || !Number.isFinite(curr) || prev >= curr;
}

/**
 * Log raw values Explorer compares before previous >= current decisions.
 * Does not modify or compensate for either timestamp.
 */
function logExplorerTimestampComparison(previous, current) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var prev = Number(previous);
  var curr = Number(current);
  var diffMs = prev - curr;
  var previousDigits = timestampDigitCount(prev);
  var currentDigits = timestampDigitCount(curr);
  var previousUnits = inferTimestampUnits(previousDigits);
  var currentUnits = inferTimestampUnits(currentDigits);
  var misordered = isTimestampMisordered(prev, curr);
  logManualProduction('----------------------------------------');
  if (options.source) {
    logManualProduction("Timestamp comparison source: ".concat(options.source));
  }
  if (options.retryNumber != null) {
    logManualProduction("retry #".concat(options.retryNumber));
  }
  logManualProduction('Previous block timestamp');
  logManualProduction(String(prev));
  logManualProduction(toIsoStringSafe(prev));
  logManualProduction("latest.timestamp digits = ".concat(previousDigits));
  logManualProduction("latest.timestamp units = ".concat(previousUnits));
  logManualProduction('');
  logManualProduction('Date.now()');
  logManualProduction(String(curr));
  logManualProduction(toIsoStringSafe(curr));
  logManualProduction("Date.now() digits = ".concat(currentDigits));
  logManualProduction("Date.now() units = ".concat(currentUnits));
  logManualProduction('');
  logManualProduction('Difference (previous - current)');
  logManualProduction("".concat(diffMs >= 0 ? '+' : '').concat(diffMs, " ms"));
  logManualProduction("".concat(diffMs >= 0 ? '+' : '').concat((diffMs / 1000).toFixed(3), " seconds"));
  logManualProduction("previous >= current: ".concat(misordered));
  logManualProduction('----------------------------------------');
  return {
    previous: prev,
    current: curr,
    diffMs: diffMs,
    previousDigits: previousDigits,
    currentDigits: currentDigits,
    previousUnits: previousUnits,
    currentUnits: currentUnits,
    misordered: misordered
  };
}
function logClockMismatchDetected(diagnostic) {
  var _context$blockHeight, _context$heartbeatMs, _context$consecutiveC;
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  logManualProduction('==================================================');
  logManualProduction('Explorer Manual Production');
  logManualProduction('CLOCK MISMATCH DETECTED');
  logManualProduction("latest.timestamp: ".concat(diagnostic.previous));
  logManualProduction("Date.now(): ".concat(diagnostic.current));
  logManualProduction("Difference: ".concat(diagnostic.diffMs >= 0 ? '+' : '').concat(diagnostic.diffMs, " ms ") + "(".concat(diagnostic.diffMs >= 0 ? '+' : '').concat((diagnostic.diffMs / 1000).toFixed(3), " s)"));
  logManualProduction("Timestamp units: latest=".concat(diagnostic.previousUnits, ", Date.now()=").concat(diagnostic.currentUnits));
  logManualProduction("Current block height: ".concat((_context$blockHeight = context.blockHeight) !== null && _context$blockHeight !== void 0 ? _context$blockHeight : 'unknown'));
  logManualProduction("Current heartbeat: ".concat((_context$heartbeatMs = context.heartbeatMs) !== null && _context$heartbeatMs !== void 0 ? _context$heartbeatMs : 'unknown', " ms"));
  logManualProduction("Consecutive misordered iterations: ".concat((_context$consecutiveC = context.consecutiveCount) !== null && _context$consecutiveC !== void 0 ? _context$consecutiveC : 'unknown'));
  logManualProduction('==================================================');
}

/**
 * Fresh read each call — no caching of block timestamp or Date.now().
 */
function fetchFreshTimestampPair(_x) {
  return _fetchFreshTimestampPair.apply(this, arguments);
}
function _fetchFreshTimestampPair() {
  _fetchFreshTimestampPair = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
    var now, blocks, latest, previousBlockTs;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          now = Date.now();
          _context.n = 1;
          return app.core.blockchain.getBlocks(1, false);
        case 1:
          blocks = _context.v;
          latest = Array.isArray(blocks) && blocks.length ? blocks[0] : null;
          previousBlockTs = latest ? Number(latest.timestamp) : 0;
          return _context.a(2, {
            now: now,
            previousBlockTs: previousBlockTs,
            latestBlockId: latest ? Number(latest.id) : null
          });
      }
    }, _callee);
  }));
  return _fetchFreshTimestampPair.apply(this, arguments);
}
module.exports = {
  timestampDigitCount: timestampDigitCount,
  inferTimestampUnits: inferTimestampUnits,
  isTimestampMisordered: isTimestampMisordered,
  logExplorerTimestampComparison: logExplorerTimestampComparison,
  logClockMismatchDetected: logClockMismatchDetected,
  fetchFreshTimestampPair: fetchFreshTimestampPair
};